<template>
    <div class="specialisms mb-2" v-if="(typeof(tyre) != 'undefined')">
        <span
            v-for="badge in specialismBadges"
            class="badge bg-navy"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="badge.description"
        >
            <b>{{ badge.name }}</b>
        </span>
    </div>
</template>

<script>
    export default {
        props: ['tyre'],
        data() {
            return {
                
            }
        },
        methods: {

        },
        computed: {
            specialismBadges() {
                let badges = [];

                if(this.tyre?.electric == 1 || this.tyre?.electric_type) {
                    badges.push({name: 'EV/HEV', description: 'This tyre is suitable for electric/hybrid vehicles. Finding the perfect balance between low rolling resistance, high grip and sturdiness.'});
                }
                if(this.tyre?.season.includes('All Season')) {
                    badges.push({name: 'All Season', description: 'All season tyres (all weather tyres) are suitable for use in weather conditions all year round.'});
                }
                if(_lowerCase(this.tyre.vehicle_type) == 'caravan') {
                    badges.push({name: 'Caravan', description: 'Caravan tyres are designed with a reinforced sidewall, which makes them more durable. This also ensures the tyres can handle the extra weight of the vehicle and its contents.'});
                }
                if(this.tyre?.rft == 1 && _lowerCase(this.tyre.rft_type) != 'ext') {
                    badges.push({name: 'RFT', description: 'Run flat tyres have been manufactured to be able to continue to perform safely, for a limited period, with no air pressure. If you suffer a puncture you will be able to safely drive to a garage in order to fix the problem.'});
                }
                if(_lowerCase(this.tyre?.rft_type) == 'ext') {
                    badges.push({name: 'EXT', description: 'Mercedes Extended Mobility Tyres utilise run flat technology, Bridgestone have developed these tyres for use only with Mercedes vehicles.'});
                }
                else if(_lowerCase(this.tyre?.rft_type) == 'driveguard') {
                    badges.push({name: 'DG', description: 'The innovative Bridgestone DriveGuard technology allows you to maintain control after a puncture, and safely continue driving for 50 miles at up to 50 mph, until it\'s safe to either repair or replace your tyre.'});
                }
                else if(_lowerCase(this.tyre?.rft_type) == 'ssr' || (this.tyre?.ssr)) {
                    badges.push({name: 'SSR', description: 'The innovative Bridgestone DriveGuard technology allows you to maintain control after a puncture, and safely continue driving for 50 miles at up to 50 mph, until it\'s safe to either repair or replace your tyre.'});
                }
                if(this.tyre?.season.includes('Summer')) {
                    badges.push({name: 'Summer', description: 'Summer tyres use a different compound designed for temperatures above 7°C. They are designed for improved handling during summer temperatures in both the wet and dry.'});
                }
                if((this.tyre?.seal == 1 && _lowerCase(this.tyre?.brand) == 'continental') || this.tyre?.contiseal) {
                    badges.push({name: 'Seal', description: 'ContiSeal™️ tyres keep you moving by immediately sealing small punctures up to 5mm in diameter (such as a nail). This allows you to keep going and change the tyre at a more appropriate time.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'continental') || this.tyre?.contisilent) {
                    badges.push({name: 'Silent', description: 'Contisilent tyres are designed to perform in every weather condition whilst reducing noise on varying road surfaces. No compromise has been made on mileage, load/speed or performance whilst mounting and storage remain the same as standard tyres.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'bridgestone')) {
                    badges.push({name: 'Silent', description: 'B-Silent technology - Reduce the noise level in your car and experience fewer vibrations thanks to a layer of sound-absorbing foam fitted inside the tyre.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'dunlop')) {
                    badges.push({name: 'Silent', description: 'Noise Shield Technology - cuts interior sound levels without compromising on the performance capabilities of the tyre.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'goodyear')) {
                    badges.push({name: 'Silent', description: 'SoundComfortTechnology - The acoustical barrier in these tyres reduces air vibrations and dampens the interior noise in your car while you are driving.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'hankook')) {
                    badges.push({name: 'Silent', description: 'Hankook “sound absorber®” tyres are designed to reduce unpleasant system-related resonances/droning frequencies which are produced at certain speeds during normal driving.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'michelin')) {
                    badges.push({name: 'Silent', description: 'Acoustic Technology - effectively reduces vibrations caused by the road resulting in a significant reduction of interior noise for easier communication and a less tiring drive.'});
                }
                if((this.tyre?.silent == 1 && _lowerCase(this.tyre?.brand) == 'pirelli')) {
                    badges.push({name: 'Silent', description: 'PNCS - Reduce cavity noise you can hear inside the car to significantly improve driving comfort. Reduces noise by between two or three decibels, which on average reduces the perceived noise by half.'});
                }
                if(_lowerCase(this.tyre.vehicle_type) == 'trailer') {
                    badges.push({name: 'Trailer', description: 'Trailer tyres are specially designed with a reinforced sidewall and thinner tread than regular tyres to make them suitable for use on a following vehicle. These tyres cannot handle speeds greater than 80mph.'});
                }
                if(this.tyre.vehicle_type == 'Commercial Van') {
                    badges.push({name: 'Van', description: 'This tyre is suitable for use on vans as it is able to cope with the extra weight and heavy loads.'});
                }
                if(this.tyre?.season.includes('Winter')) {
                    badges.push({name: 'Winter', description: 'Winter tyres use a different compound designed for temperatures below 7°C. They improve grip in the cold and some have studs to help grip on snow and ice.'});
                }
                if(this.tyre?.xl == 'XL') {
                    badges.push({name: 'XL', description: 'XL stands for Extra Load. They use a more reinforced compound to carry heavier loads, but are the same size as normal tyres. If your car had XL tyres factory fitted then you must choose XL tyres for any new ones you buy.'});
                }
                if(this.tyre?.vehicle_type == 'Passenger 4x4') {
                    badges.push({name: '4x4', description: 'These types of cars require special tyres to ensure even tyre wear throughout the lifetime of the tyre and to be able to perform on off-road conditions.'});
                }
                if(this.tyre?.three_peaks == 1) {
                    badges.push({name: '3PMSF', description: 'The 3PMSF symbol on winter tyres ensures their reliability and safety in snowy driving conditions. This certification is granted by a certified laboratory after the tyre has undergone standardised regulatory testing for both mobility and safety on snow.'});
                }
                if(this.tyre?.ice_grip == 1) {
                    badges.push({name: 'M+S', description: 'M+S winter tyres, denoting mud and snow suitability, are better equipped for navigating snowy or muddy roads compared to standard models like summer tyres. Keep in mind that this marking is entirely at the discretion of the manufacturer and doesn\'t necessitate passing a certified test.'});
                }

                return badges;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .specialisms {
        span {
            cursor: default;
            &:not(:last-of-type) {
                margin-right: 0.2rem !important;
            }
            b {
                font-weight: 500;
                font-size: 12px;
                text-transform: uppercase;
                color: #fff;
            }
        };
    }
</style>